import { MedmalStepService } from './../../../Services/MedmalStepService';
import { Component } from '@angular/core';
@Component({
    selector: 'MedmalProposalForm',
    templateUrl: './MedmalProposalForm.html',
    styleUrls: ['./MedmalProposalForm.css']
  })
export class MedmalProposalForm
{
public FirstStep:boolean=false;
public SecondStep:boolean=false;
public ThirdStep:boolean=false;
public isShowLoading:boolean=false;

public constructor(private medStepService: MedmalStepService)
{
 this.medStepService.getStepNum().subscribe(StepNo=>{

  this.setProgressBar(StepNo);
 });
}
public setProgressBar(stepNo:string)
{
if(stepNo=="3")
{
  this.FirstStep=true;
  this.SecondStep=true;
  this.ThirdStep=true;
}
else if(stepNo=="2")
{
  this.FirstStep=true;
  this.SecondStep=true;
  this.ThirdStep=false;
}
else if(stepNo=="1")
{
  this.FirstStep=true;
  this.SecondStep=false;
  this.ThirdStep=false;
}
else
{
  this.FirstStep=false;
  this.SecondStep=false;
  this.ThirdStep=false;
}
}

    

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MedmalPortal/MedmalProposalForm/MedmalProposalForm.ts